import React from 'react'
import { Input } from '@/components/shadcn/input'
import { IconSearchOutline, IconCloseOutline } from '@/components/icons'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = 'h-full w-48 pl-8 pr-8',
}: SearchInputProps) {
  return (
    <div className="relative">
      <Input
        placeholder={placeholder}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        className={className}
      />
      <IconSearchOutline size={16} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-1 focus:ring-ring"
        >
          <IconCloseOutline size={14} />
        </button>
      )}
    </div>
  )
}
